import React, { useEffect, useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { useNavigate } from "react-router-dom";

import { Box, Button, Stack, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useTheme } from "@mui/material/styles";

import { Add } from "@mui/icons-material";

import { HomePageMenu } from "@/components/molecules";
import { PageContainer } from "@/components/containers";
import { defaultLogo, getClientComponent, useLogo } from "@/utils";
import { useDemo } from "@/context";


const HomePage: React.FC = () => {
  const { user } = useAuth0();
  const theme = useTheme();
  const mode = theme.palette.mode;
  const navigate = useNavigate();
  const { isDemoMode, demoClient } = useDemo();

  const logoConfig = useLogo();
  const HomeLogo = logoConfig?.home?.[mode]?.logo;
  const [logoSize, setLogoSize] = useState<number>(720);

  useEffect(() => {
    if (logoConfig && logoConfig.home){
      setLogoSize(logoConfig.home[mode].width)
    } else {
      setLogoSize(720);
    }
  }, [logoConfig, mode])

  const pageDisabled = isDemoMode && !demoClient;

  const Menu = getClientComponent(
    "HomePageMenu",
    HomePageMenu
  );

  return (
    <PageContainer>
      <Grid
        container
        spacing={2}
        display="flex"
        justifyContent="center"
      >
        {pageDisabled ? (
          <Grid size={12}>
            <Typography
              sx={{
                pt: 4,
                textAlign: "center"
              }}
            >
              Select a client to get started.
            </Typography>
          </Grid>
        ) : (
          <>
            <Grid size={12} display="flex" justifyContent="center">
              <Box width={logoSize} mb={1}>
                {HomeLogo ? <HomeLogo /> : defaultLogo}
              </Box>
            </Grid>
            <Menu />
          </>
        )}
      </Grid>
    </PageContainer>
  );
};

export default HomePage;
